import { Grid } from "@material-ui/core";
import React from "react";
import HandShakeLogo from "components/logos/hand-shake-logo";
import ItsmeLogo from "components/logos/itsme-logo";
import PortimaLogo from "components/logos/portima-logo";

const Header = (): React.ReactElement => {
    return (
        <Grid container style={{ marginBottom: "1em" }}>
            <Grid item xs={4} />
            <Grid item xs={4}>
                <PortimaLogo paddingTop="1em" />
                <HandShakeLogo />
                <ItsmeLogo />
            </Grid>
            <Grid item xs={4} />
        </Grid>
    );
};

export default Header;
